import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { AfLimitToPipe } from '@shared/filters/af-limit-to/af-limit-to.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { AfTranslateDirective } from '../../../../shared/modules/translate/directive/af-translate.directive';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { FilterBySearchAndOrderComponent } from "../../../../shared/components/filter-by-search-and-order/filter-by-search-and-order.component";
import { FilterByListAndOrderComponent } from "../../../../shared/components/filter-by-list-and-order/filter-by-list-and-order.component";
import { SpanTooltipComponent } from "../../../../shared/components/span-tooltip/span-tooltip.component";
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'duplicate-documentation-publication',
  templateUrl: './duplicate-documentation-publication.component.html',
  standalone: true,
  imports: [
    ProgressSpinnerModule,
    AfTranslateDirective,
    AfOrderByPipe,
    AfLimitToPipe,
    FilterBySearchAndOrderComponent,
    FilterByListAndOrderComponent,
    SpanTooltipComponent
  ]
})
export class DuplicateDocumentationPublicationComponent implements OnInit{
  @Input() filterConceptList: any = [];
  @Input() duplicateDocumentation: any;
  @Output() sendAction =  new EventEmitter();

  constructor(private translate: AfTranslateFactory) { }

  ngOnInit(): void {
    this.duplicateDocumentation.tituloFilter = {
      name: this.translate.instant('common.title'),
      filterOrder: 'titulo',
    };
    this.duplicateDocumentation.isbnFilter = { name: this.translate.instant('concept-list.isbn-signature') };
    this.duplicateDocumentation.tipoFilter = { name: this.translate.instant('common.type') };
    this.duplicateDocumentation.filterOrder = 'titulo';
    this.duplicateDocumentation.order = false;
    this.duplicateDocumentation.filters = ['tipo'];
    this.sendAction.emit({action: 'getFilters'});
  }

  selectInstance(instance:any){
    this.sendAction.emit({
      action: 'selectInstance',
      instance: instance
    })
  }

  filterOrder(e:any, type:any){
    this.sendAction.emit({
      action: 'filterOrder',
      type: type,
      event: e
    })
  }

  changeCurrentPage(e:any){
    this.sendAction.emit({
      action: 'changeCurrentPage',
      event: e
    })
  }

}
